import { Component } from "react";

// The app had no error boundary, so any exception thrown while rendering a page (an unexpected
// undefined, a malformed record, an object rendered as a child) unmounted the WHOLE tree and left
// a blank screen until reload. This contains it to the page area: navigation stays usable, and
// changing `resetKey` (the route) clears the error so moving to another page recovers without a reload.
export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] page render failed:", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" className="max-w-lg mx-auto mt-16 bg-white border border-red-200 rounded-xl p-6 text-center space-y-3">
        <h2 className="text-lg font-semibold text-red-700">משהו השתבש בטעינת העמוד</h2>
        <p className="text-sm text-gray-600">
          ניתן לעבור לעמוד אחר בתפריט, או לטעון את העמוד מחדש. אם הבעיה חוזרת, דווחו למנהל המערכת.
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="bg-brand-600 hover:bg-brand-700 text-white px-4 py-2 rounded-lg text-sm font-medium"
        >
          טעינה מחדש
        </button>
      </div>
    );
  }
}
